import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  HIDE_REMOVE_CONTRIBUTOR_DIALOG,
  REMOVE_CONTRIBUTOR,
} from "file-details/fileDetailsActions";
import {
  getContributor,
  getRemoveContributorDialogIndex,
  getRemoveContributorDialogVisible,
} from "common/selectors";
import { formatContributorName } from "common/stringFormat";
import ConfirmationDialog from "general-components/ConfirmationDialog";
import { useTranslation } from "react-i18next";

const RemoveContributorDialog = () => {
  const { t, i18n } = useTranslation();
  const index = useSelector(getRemoveContributorDialogIndex);
  const visible = useSelector(getRemoveContributorDialogVisible);
  const contributor = useSelector(getContributor(index));

  const dispatch = useDispatch();
  const onConfirm = (index) => () =>
    dispatch({ type: REMOVE_CONTRIBUTOR, index });
  const onCancel = () => dispatch({ type: HIDE_REMOVE_CONTRIBUTOR_DIALOG });

  return (
    <ConfirmationDialog
      title={t("file_details_remove_contributor_title")}
      message={t("file_details_remove_contributor_message", {
        name: formatContributorName(contributor, i18n.dir() === "rtl"),
      })}
      confirmButtonText={t("confirmation_yes")}
      onCancel={onCancel}
      onConfirm={onConfirm(index)}
      visible={visible}
    />
  );
};

export default RemoveContributorDialog;
